import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  NgWizardConfig,
  NgWizardService,
  STEP_STATE,
  StepChangedArgs,
  THEME,
} from 'ng-wizard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { RootService } from 'src/app/shared/services/root.service';
import * as unbxUrl from '../../../../assets/unbx-script';
import { v4 as uuidv4 } from 'uuid';
import { debounceTime, distinctUntilChanged, filter, Subject, take } from 'rxjs';
import { WebsocketService } from 'src/app/websocket.service';
import { CookieService } from 'src/app/shared/services/cookie.service';
import { environment } from '../../../../environments/environment';
declare var $: any;

@Component({
  selector: 'app-finance-booking',
  templateUrl: './finance-booking.component.html',
  styleUrls: ['./finance-booking.component.scss'],
})
export class FinanceBookingComponent implements OnInit {
  productDetailsData: any;
  totalAmount: any;

  @Output() quantityChange = new EventEmitter<{
    quantity: any;
    totalAmount: any;
  }>();
  @Output() VCPriceChange = new EventEmitter<{ newVCPrice: any }>();

  @Output() dealerData = new EventEmitter<{ dealerDataList: any }>();
  step: any;
  isValidTypeBoolean: boolean = true;
  dealerCode: any;
  dealerLen: any;
  dealerList: any;
  checkBoxcheked:boolean=false;
  financeDealerCode: any = [];
  emptyDealer: boolean = false;
  disableFields: boolean;
  vc: any;
  utmdata: any;
  newVCPriceChange: any;
  dealername: any;
  isAdhaarNoAvailable: any;
  isDisabled: boolean = false;
  typeOfBooking: string;
  encryptAdharNO: any;
  errormessagefni: any;
    iswhtAppVisible: boolean = true;
  submitted: boolean = false;
  usefniLead: any;
  pinCodeByLatLong: any;
  isKycFetchedData :boolean = false;
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']
  isProceeding: boolean = false;
  isValidFunctionReturnsBoolean() {
    return true;
  }
  isValidFunctionReturnsObservable() {
    return true;
  }
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden,
  };
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      showPreviousButton: false,
      showNextButton: false,
    },
  };
  ProductQuantity: any;
  isPanVerified: boolean = false;
  isAdhaarVerified: boolean = false;
  isAdhaarValid: boolean = false;
  kycKarzaRes: any;

  dseLoaded: boolean = false;
  dseList: any[];

  translatedFirstName;
  translatedLastName;
  translatedAddress1;
  translatedAddress2;
  EddData: any;

  disableSubmitButton: boolean = false;
  address: any;
  rowID: any;
  sub: Subscription = new Subscription();
  bookingFNIForm: FormGroup;
  userData: any;
  reqID: any;
  paymentType: any;
  isProcess: boolean = false;
  fniOpty: any;
  fniOptyStatus: any;
  apiCount: any = 1;
  isOptyFailed: any;
  fniBegin: any = false;
  PanValue: string = '';
  stateList: any = [];
  districtList: any = [];
  cityList: any = [];
  talukaList: any = [];
  pincodeList: any = [];
  stock: number = 0;
  panTypeOptions = [
    { label: 'Individual', value: 'Individual' }
    // { label: 'Company (including Partnership, Trust, Society, School, Hospital etc.)', value: 'Company' }
  ];
  disabledCity: boolean = false;
  quantity: any = 1;
  divData = [];
  divisions = [];
  productId: any;
  dseMatch: boolean = false;
  VasData: any;
  isVasAvailable: any = false;

  isViaConfigurator: any = false;

  dse: any[];
  productOfferData: any = [];
  btndisablefn: boolean = false;
  private clickSubject = new Subject<void>();
  private readonly debounceTimeInMillis = 300;
  isSmart: boolean = false;
  emptyDealerFni: boolean = false;
  checkPan: boolean = false;
  fni_dealercode: any;
  opty_idfnijourney: string;
  opty_status_fnijourney: string;
  dse_loginFni: any;
  fniUserData: any;
  fniOspGetlead: any;
  encryptPanNOFni: any;
  encryptAdharNOFni: any;
  statesData = []
  stateData:any[];
  selectedState: string | null = null;
  @ViewChild('panInput') panInput: ElementRef;
  row_idfnijourney: string;
  payment_data:any = []
  isfnijourney :boolean = false;
  fullNamedata: any;
  ispanData: any;
   socket_Id: string;
  timeLeft: any;
  isTimer: boolean = false;
  m: any;
  s: any
  constructor(
    private formErrorService: FormErrorService,
    private formBuilder: FormBuilder,
    private behaviourSubject: BehaviourSubjectService,
    private regexService: RegexService,
    private route: ActivatedRoute,
    private rootService: RootService,
    private toastrService: ToastrService,

    private spinner: NgxSpinnerService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
    private localStorage: secureStorage,
    private activatedRoute: ActivatedRoute,
    private ngWizardService: NgWizardService,
    private cleverService: ClevertapService,
    private CommonService: CommonService,private websocketService :WebsocketService,private ssrcookieService: CookieService,
  ) {
    this.clickSubject.pipe(
      debounceTime(this.debounceTimeInMillis),
      distinctUntilChanged()
    );
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.activatedRoute.paramMap.subscribe((params) => {
        this.typeOfBooking = params.get('type');
        this.fni_dealercode = params.get('dealer_code');
        if (this.fni_dealercode && this.fni_dealercode.includes('?')) {
          this.fni_dealercode = this.fni_dealercode.split('?')[0];
        }
        if (this.fni_dealercode) {
          this.emptyDealerFni = true;
        } else {
          this.emptyDealerFni = false;
        }
      });
      this.route.queryParamMap.subscribe((params) => {
        this.opty_idfnijourney = params.get('optyId');
        this.opty_status_fnijourney = params.get('status');
        this.dse_loginFni = params.get('dse_loginFni');
        this.row_idfnijourney = params.get('row_id');
      });
      if (this.row_idfnijourney) {
        this.isfnijourney = true;
        this.getPaymentData(this.row_idfnijourney)
      }
      else{
        this.isfnijourney = false;
      }
      if (this.typeOfBooking === 'FinanceJourneyNonOsp') {
        this.getOptyData(this.opty_idfnijourney, 0);
      }
      if (this.typeOfBooking === 'FinanceJourney') {
        this.getleadData(this.opty_idfnijourney);
      }
      this.productOfferData = JSON.parse(
        this.localStorage.getItem('productOfferData')
      );
      this.behaviourSubject.isSmart.subscribe((res) => {
        if (res) {
          this.isSmart = res;
        } else {
          this.isSmart = false;
        }
      });
    }
    this.sub.add(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params['dealer']) {
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('dealercd', params['dealer']);
            localStorage.setItem('vc', params['vc']);
            this.vc = params['vc'];
          }
        }
      })
    );
    this.dealerCode = localStorage.getItem('dealercd');
    if (localStorage.getItem('dealercd')) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
    this.VasData = this.localStorage.getItem('VASData')
      ? JSON.parse(this.localStorage.getItem('VASData'))
      : null;
    this.isVasAvailable = this.VasData?.VasAvailable == 'YES' ? true : false;
    this.isViaConfigurator = this.VasData?.isViaConfigurator;
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get('id')) {
        this.productId = params.get('id');
      }
    });
    this.getVehicleDetail();
    this.bookForm();
    if (
      this.typeOfBooking !== 'FinanceJourneyNonOsp' &&
      this.typeOfBooking !== 'FinanceJourney'
    ) {
      this.getUserDetails();
    }

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView('OSP Finance');
      } catch {}
    }
    this.sub.add(
      this.route.params.subscribe((params: Params) => {
        this.rowID = params['rowID'];
      })
    );

    this.utmdata = JSON.parse(this.localStorage.getItem('myObject'));
    this.findDealersNew();
  }
  getEddData() {
    try {
      this.sub.add(
        this.apiService
          .getS3Data('Anaplan/AnaplanCVEnquiryMTO.json')
          .subscribe({
            next: (res: any) => {
              this.EddData = res.data;
            },
            error: () => {},
            complete: () => {},
          })
      );
    } catch (error) {}
  }
  bookForm() {
    this.bookingFNIForm = this.formBuilder.group({
      first_name: ['',[Validators.required]],
      last_name: [''],
      email_id: ['',[Validators.required, Validators.pattern(this.regexService.Email)],
      ],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      state: ['', [Validators.required]],
      district: ['', [Validators.required]],
      city: ['', [Validators.required]],
      taluka: ['', [Validators.required]],
      pincode: [
        '',
        [Validators.required, Validators.pattern(this.regexService.Pincode)],
      ],
      mobile_number: [
        '',
        [Validators.required, Validators.pattern(this.regexService.Phone)],
      ],
      AMC: ['No', ''],
      is_tml: ['True'],
      interested_in_exchange: ['No'],
      lease_interest: ['No', ''],
      financier: ['Yes', ''],
      bookingAmount: ['No'],
      amount: [''],
      // quantity: ["", [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)],],
      quantity: [
        '1',
        [
          Validators.required,
          Validators.maxLength(2),
          Validators.min(1),
          Validators.max(10),
        ],
      ],
      panNo: [
        '',
        [Validators.required, Validators.pattern(this.regexService.Pan)],
      ],
      aadhar: [
        this.userData
          ? this.isAdhaarNoAvailable
            ? this.isAdhaarNoAvailable
            : ''
          : '',
      ],
      division_id: ['', Validators.required],
      finance: [''],
      registration_number: [''],
      chassis_number: [''],
      pi_for_exchange: [''],
      manufacture_year: [''],
      mileage: [''],
      brand: [''],
      dse: [''],
      full_name: [ '',[Validators.required],
      ],
      pan_type: ['Individual', Validators.required],
    });
    this.bookingFNIForm.get('pan_type')?.valueChanges.subscribe(value => {
      this.updateFirstNameValidation(value);
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.bookingFNIForm.controls;
  }

  getUserDetails() {
    let res = this.rootService.isLoggedIn();
    if (res) {
      this.sub.add(
        this.apiService.getUserData().subscribe({
          next: (response: any) => {
            this.rootService.setUser(response['data']);
            this.rootService.setUserId(response['data']);
            this.userData = [];
            this.userData = response['data'];
            const firstName = this.CommonService.replaceUnicode(this.userData.first_name) || '';
             const lastName = this.CommonService.replaceUnicode(this.userData.last_name) == '.' ? '' : this.CommonService.replaceUnicode(this.userData.last_name) || '';
            this.fullNamedata = `${firstName}${lastName}`.trim();
            this.getLoyalitySignup();
            if (this.userData?.user_documents) {
              for (let i = 0; i < this.userData.user_documents?.length; i++) {
                if (
                  this.userData.user_documents[i].document_description ==
                  'aadhar_card'
                ) {
                  // let adhaarNo = this.userData.user_documents[i].doc_number;
                  // this.bookingFNIForm.controls['aadhar'].setValue(adhaarNo);
                  this.isAdhaarNoAvailable =
                    this.userData.user_documents[i].doc_number;
                  this.bookingFNIForm.controls['aadhar'].setValue(
                    this.isAdhaarNoAvailable
                  );
                  this.bookingFNIForm.get('aadhar').updateValueAndValidity();
                  this.isAdhaarVerified = this.userData.user_documents[i].e_kyc;
                  this.isAdhaarValid = this.userData.user_documents[i].e_kyc;
                } else {
                  let panNo = this.userData.user_documents[i].doc_number;
                  if (this.bookingFNIForm.value.pan_type === 'Individual' && panNo[3]!=='P') {
                    this.checkPan=true
                  } else if(panNo[3]==='P' &&this.bookingFNIForm.value.pan_type === 'Company'){
                    this.checkPan=true
                  }
                  else{
                    this.checkPan=false
                  }
                  this.bookingFNIForm.controls['panNo'].setValue(panNo);
                  this.bookingFNIForm.get('panNo').updateValueAndValidity();
                  this.isPanVerified = this.userData.user_documents[i].e_kyc;
                }
              }
            }
            this.setForm(this.userData);
          },
        })
      );
    } else {
      this.toastrService.warning('Kindly Login');

      this.router.navigate(['/login/']);
    }
  }

  setForm(userData) {
    let statecodes = '';
    let statedata = [];

    let adhaarNo;
    let panNo;
    if (
      this.userData?.user_documents &&
      (this.typeOfBooking !== 'FinanceJourneyNonOsp' &&
      this.typeOfBooking !== 'FinanceJourney')
    ) {
      for (let i = 0; i < this.userData.user_documents?.length; i++) {
        if (
          this.userData.user_documents[i].document_description == 'aadhar_card'
        ) {
          this.isAdhaarNoAvailable =
            this.userData.user_documents[i].doc_number == ' '
              ? this.userData.user_documents[i].doc_number.replace(/\s/g, '')
              : this.userData.user_documents[i].doc_number;
          this.bookingFNIForm.controls['aadhar'].setValue(
            this.isAdhaarNoAvailable
          );
          // adhaarNo = this.userData.user_documents[i].doc_number;
          // this.bookingFNIForm.controls['aadhar'].setValue(adhaarNo);
          this.bookingFNIForm.get('aadhar').updateValueAndValidity();
          this.isAdhaarVerified = this.userData.user_documents[i].e_kyc;
          this.isAdhaarValid = this.userData.user_documents[i].e_kyc;
        } else {
          panNo = this.userData.user_documents[i].doc_number;
          this.bookingFNIForm.controls['panNo'].setValue(panNo);
          this.bookingFNIForm.get('panNo').updateValueAndValidity();
          this.isPanVerified = this.userData.user_documents[i].e_kyc;
        }
      }
    }
    if ( this.typeOfBooking === 'FinanceJourneyNonOsp') {
      if (this.fniUserData?.PR_CONTACT_PAN_s) {
        let pan=this.fniUserData?.PR_CONTACT_PAN_s;
        if (pan[3]!=='P' && pan.length>3 && pan !== null && this.bookingFNIForm.value.pan_type === 'Individual') {
          this.checkPan=true
        } else if(pan[3]==='P' && pan.length>3 && pan !== null && this.bookingFNIForm.value.pan_type === 'Company'){
          this.checkPan=true
        }else{
    this.checkPan=false
  }
        this.isPanVerified=true;
      }
      else{
        this.isPanVerified=false;
      }
    }
    if ( this.typeOfBooking === 'FinanceJourney') {
      if (this.fniOspGetlead?.lead_pan_no) {
        let pan=this.fniOspGetlead?.lead_pan_no;

        if (pan[3]!=='P' && pan.length>3 && pan !== null && this.bookingFNIForm.value.pan_type === 'Individual') {
          this.checkPan=true
        } else if(pan[3]==='P' && pan.length>3 && pan !== null && this.bookingFNIForm.value.pan_type === 'Company'){
          this.checkPan=true
        }
        else{
          this.checkPan=false
        }
        this.isPanVerified=true;
      }
      else{
        this.isPanVerified=false;
      }
    }
    this.bookingFNIForm = this.formBuilder.group({
      first_name: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_FST_NAME_s
            ? this.fniUserData?.PR_CONTACT_FST_NAME_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.user_first_name
            ? this.fniOspGetlead?.user_first_name
            : ''
          : userData?.first_name,
        [
          Validators.required
        ],
      ],
      last_name: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_LAST_NAME_s
            ? this.fniUserData?.PR_CONTACT_LAST_NAME_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.user_last_name
            ? this.fniOspGetlead?.user_last_name
            : ''
            : userData?.last_name === '.' ? '' : userData?.last_name,
      ],
      email_id: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_EMAIL_ADDR_s
            ? this.fniUserData?.PR_CONTACT_EMAIL_ADDR_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.email_id
            ? this.fniOspGetlead?.email_id
            : ''
          : userData?.email_id,
        [Validators.required, Validators.pattern(/^\w+([\.]?\w+)*@\w+([\.]?\w+)*(\.\w{2,3})+$/)],
      ],
      address1: ['', [Validators.required]],
      address2: [
        userData?.address_two ? userData?.address_two : '',
        [Validators.required],
      ],
      mobile_number: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_CELL_PH_NUM_s
            ? this.fniUserData?.PR_CONTACT_CELL_PH_NUM_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.usefniLead?.mobile_number
            ? this.usefniLead?.mobile_number
            : ''
          : userData?.mobile_number,
        [Validators.required, Validators.pattern(this.regexService.Phone)],
      ],
      state: [statecodes ? statecodes : '', [Validators.required]],
      district: [
        statedata?.length == 0 ? '' : userData?.district?.toLowerCase(),
        [Validators.required],
      ],
      city: ['', [Validators.required]],
      taluka: ['', [Validators.required]],
      pincode: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_ZIPCODE_s
            ? this.fniUserData?.PR_CONTACT_ZIPCODE_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.pincode
            ? this.fniOspGetlead?.pincode
            : ''
          : '',
        [Validators.required, Validators.pattern(this.regexService.Pincode)],
      ],
      AMC: [
        userData
          ? userData?.amc
            ? userData?.amc
            : this.isVasAvailable
            ? 'yes'
            : 'No'
          : this.isVasAvailable
          ? 'yes'
          : 'No',
        '',
      ],
      is_tml: ['True', Validators.required],
      interested_in_exchange: [
        userData
          ? userData?.interested_in_exchange
            ? userData?.interested_in_exchange
            : 'No'
          : 'No',
      ],
      lease_interest: [
        userData
          ? userData?.lease_interest == null
            ? 'No'
            : userData?.lease_interest
          : 'No',
        '',
      ],
      // quantity: [userData ? userData.quantity : "", [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)]],
      quantity: [
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.QTY_s
            ? this.fniUserData?.QTY_s
            : '1'
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.quantity
            ? this.fniOspGetlead?.quantity
            : ''
          : '1',
        [
          Validators.required,
          Validators.maxLength(2),
          Validators.min(1),
          Validators.max(10),
        ],
      ],
      panNo: [this.typeOfBooking === 'FinanceJourneyNonOsp' ? (this.fniUserData?.PR_CONTACT_PAN_s ? this.fniUserData?.PR_CONTACT_PAN_s :''):this.typeOfBooking === 'FinanceJourney' ? (this.fniOspGetlead?.lead_pan_no ? this.fniOspGetlead?.lead_pan_no :''):this.userData ? panNo ? panNo : "" : "", [Validators.required, Validators.pattern(this.regexService.Pan), this.hasPatterncheckError()]],

      aadhar: [this.typeOfBooking === 'FinanceJourneyNonOsp' ?'':this.typeOfBooking === 'FinanceJourney' ? (this.fniOspGetlead?.lead_aadhar_number ? this.fniOspGetlead?.lead_aadhar_number :''):this.userData ? this.isAdhaarNoAvailable ? this.isAdhaarNoAvailable : "" : "",   [
        this.bookingFNIForm.value.pan_type || this.userData?.account_type === 'Individual' ? Validators.required : null,
        Validators.pattern(this.regexService.Aadhar),
      ].filter(Boolean), ],
      division_id: [
        userData
          ? userData?.dealer_info?.division_id
            ? userData?.dealer_info?.division_id
            : ''
          : '',
        Validators.required,
      ],
      financier: [
        userData ? (userData?.finance == 'SELF' ? 'No' : 'Yes') : 'Yes',
        '',
      ],
      bookingAmount: ['No', ''],
      amount: [''],
      finance: [userData ? (userData?.finance ? userData?.finance : '') : ''],
      registration_number: [''],
      chassis_number: [''],
      pi_for_exchange: [''],
      manufacture_year: [''],
      mileage: [''],
      brand: [''],
      financeType: ['No', [Validators.required]],
      dse: [''],
      pan_type: ['Individual', Validators.required],
        full_name: [this.fullNamedata],
    });
    let quantity = this.bookingFNIForm.value.quantity;
    if (quantity) {
      this.ProductQuantity = quantity;
      this.quantity = this.ProductQuantity;
    }
    if (
      this.fniUserData?.PR_CONTACT_ZIPCODE_s &&
      this.typeOfBooking === 'FinanceJourneyNonOsp'
    ) {
      this.addressByPincode();
    }
    if (
      this.fniOspGetlead?.pincode &&
      this.typeOfBooking === 'FinanceJourney'
    ) {
      this.addressByPincode();
    }
    if (
      Number(this.fniUserData?.QTY_s) > 1 &&
      this.typeOfBooking === 'FinanceJourneyNonOsp'
    ) {
      this.getQuantity();
    }
    if (
      this.fniOspGetlead?.quantity > 1 &&
      this.typeOfBooking === 'FinanceJourney'
    ) {
      this.getQuantity();
    }
     if(this.userData?.user_documents?.length>0){
        this.iswhtAppVisible = this.userData.user_documents?.[0]?.e_kyc ? false : true
      }
      if (this.typeOfBooking === 'FinanceJourney') {
        if ((this.fniOspGetlead?.lead_aadhar_number && this.fniOspGetlead?.lead_aadhar_number !='' && this.fniOspGetlead?.lead_aadhar_number != null) && (this.fniOspGetlead?.lead_pan_no && this.fniOspGetlead?.lead_pan_no !='' && this.fniOspGetlead?.lead_pan_no != null)) {
          this.iswhtAppVisible = false;
        }
        else
        {
          this.iswhtAppVisible = true;
        }
      }
    this.pinCodeByLatLong = JSON.parse(localStorage.getItem("userPincode"));
    this.bookingFNIForm.patchValue({ pincode: this.pinCodeByLatLong })
    if(this.pinCodeByLatLong){
      this.addressByPincode();
    }
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  getQuantity() {
    this.ProductQuantity = this.bookingFNIForm.value.quantity
      ? this.bookingFNIForm.value.quantity
      : 1;
    this.quantity = this.ProductQuantity;

    if (this.ProductQuantity == '0') {
      this.bookingFNIForm.patchValue({
        quantity: '1',
      });
      this.ProductQuantity = 1;
    }
    // this.totalAmount =
    //   this.productDetailsData['down_payment'] *
    //   this.bookingFNIForm.controls['quantity'].value;
    if(this.isfnijourney && this.payment_data?.length > 0){
      this.totalAmount = (this.payment_data[0]?.amount) * (this.bookingFNIForm.controls['quantity'].value);
    }else
    {
      this.totalAmount = (this.productDetailsData["down_payment"]) * (this.bookingFNIForm.controls['quantity'].value);
    }
    this.quantityChange.emit({
      quantity: this.bookingFNIForm.controls['quantity'].value,
      totalAmount: this.totalAmount,
    });
  }
  stepChanged(args: StepChangedArgs) {
    this.step = args.step.title;
  }
  showPreviousStep() {
    this.ngWizardService.previous();
  }

  showNextStep() {
    this.disableSubmitButton = true;
    if (
      (this.bookingFNIForm.controls['aadhar'].value != ' ' &&
        !this.isVasAvailable &&
        this.bookingFNIForm.controls['aadhar'].value == ' ' &&
        this.isVasAvailable) ||
      (this.bookingFNIForm.controls['panNo'].value == ' ' &&
        !this.isVasAvailable &&
        this.bookingFNIForm.controls['panNo'].value == ' ' &&
        this.isVasAvailable)
    ) {
      if (
        this.bookingFNIForm.controls['aadhar'].value != this.regexService.Aadhar
      ) {
        this.bookingFNIForm.controls['aadhar'].setValidators([
          Validators.pattern(this.regexService.Aadhar),
        ]);
        this.bookingFNIForm.controls['aadhar'].updateValueAndValidity();
      }
      if (
        this.bookingFNIForm.controls['panNo'].value != this.regexService.Pan
      ) {
        this.bookingFNIForm.controls['panNo'].setValidators([
          Validators.pattern(this.regexService.Pan),
        ]);
        this.bookingFNIForm.controls['panNo'].updateValueAndValidity();
      }
    }
    if (this.bookingFNIForm.status === 'INVALID') {
      this.disableSubmitButton = false;
      this.formErrorService.displayFormErrors(this.bookingFNIForm);
      return;
    }
    // if(this.bookingFNIForm.controls["aadhar"].status == "INVALID"    ){
    if (
      this.bookingFNIForm.controls['aadhar'].value != this.regexService.Aadhar
    ) {
      this.bookingFNIForm.controls['aadhar'].setValidators([
        Validators.pattern(this.regexService.Aadhar),
      ]);
      this.bookingFNIForm.controls['aadhar'].updateValueAndValidity();
    }
    // }

    this.submitFniForm();
  }
  checkDSE(event: any) {
    this.dse = [];
    this.dseLoaded = false;

    if (this.bookingFNIForm.value.dse && this.dseList?.length > 0) {
      this.dseMatch = false;
      this.dseLoaded = false;

      this.dse = [];

      this.dseList.forEach((element) => {
        if (
          element.username?.toLowerCase() ==
          this.bookingFNIForm.value.dse?.toLowerCase()
        ) {
          this.dseMatch = true;
          this.dse = element;
          this.dseLoaded = true;
        }
      });
      if (!this.dseMatch) {
        this.dseLoaded = true;
        // this.toastrService.error("Provided DSE/NSE/DDSO/DSM/NDRM/DSAdmin CRM ID does not match with the dealer.")
      }
    }

    event.stopPropagation();
    event.preventDefault();
  }
  submitFniForm() {
     if (this.isProceeding) {
      return; // Prevent further clicks
    }
    this.isProceeding = true;
    this.submitted = true;
    this.disableSubmitButton = true;
    if (
      this.bookingFNIForm.value.quantity == 0 ||
      this.bookingFNIForm.value.quantity == '' ||
      this.bookingFNIForm.value.quantity == null
    ) {
      this.disableSubmitButton = false;
      const type = this.bookingFNIForm.get('quantity');
      type.setValidators([Validators.required, Validators.maxLength(2)]);
      type.updateValueAndValidity();

      this.formErrorService.displayFormErrors(this.bookingFNIForm);
       this.isProceeding = false;
      return;
    }
    if (
      this.bookingFNIForm.value.email_id == '' ||
      this.bookingFNIForm.value.email_id == null
    ) {
      this.disableSubmitButton = false;
      const type = this.bookingFNIForm.get('email_id');
      type.setValidators([
        Validators.required,
        Validators.pattern(this.regexService.Email),
      ]);
      type.updateValueAndValidity();

      this.formErrorService.displayFormErrors(this.bookingFNIForm);
      this.isProceeding = false;
      return;
    }
    if (this.bookingFNIForm.value.address1 == '') {
      this.disableSubmitButton = false;
      const type = this.bookingFNIForm.get('address1');
      type.setValidators([Validators.required]);
      type.updateValueAndValidity();
      this.formErrorService.displayFormErrors(this.bookingFNIForm);
      this.isProceeding = false;
      return;
    }

    if (
      (this.bookingFNIForm.controls['aadhar'].value != ' ' &&
        !this.isVasAvailable) ||
      (this.bookingFNIForm.controls['panNo'].value != ' ' &&
        !this.isVasAvailable)
    ) {
      if (
        this.bookingFNIForm.controls['aadhar'].value != this.regexService.Aadhar
      ) {
        // this.isAdhaarVerified = false

        this.bookingFNIForm.controls['aadhar'].setValidators([
          Validators.pattern(this.regexService.Aadhar),
        ]);
        this.bookingFNIForm.controls['aadhar'].updateValueAndValidity();
      }
      if (
        this.bookingFNIForm.controls['panNo'].value != this.regexService.Pan
      ) {
        this.bookingFNIForm.controls['panNo'].setValidators([
          Validators.pattern(this.regexService.Pan),
        ]);
        this.bookingFNIForm.controls['panNo'].updateValueAndValidity();
      }
    }
    if ((!this.isAdhaarVerified || !this.isPanVerified) && this.isVasAvailable && this.bookingFNIForm.value.pan_type === 'Individual') {
      this.toastrService.warning('Kindly Verify the e-KYC')

      this.spinner.hide()
      this.disableSubmitButton = false;
      this.isProceeding = false;  
      return;
    }
    if ((!this.isPanVerified) && this.isVasAvailable && this.bookingFNIForm.value.pan_type === 'Company') {
      this.toastrService.warning('Kindly Verify the e-KYC')

      this.spinner.hide()
      this.disableSubmitButton = false;
      this.isProceeding = false;
      return;
    }
    if (
      this.bookingFNIForm.controls['aadhar'].value &&
      this.bookingFNIForm.controls['aadhar'].value?.length > 1 &&
      this.bookingFNIForm.controls['aadhar'].value?.length < 12
    ) {
      this.isAdhaarValid = false;
    } else {
      this.isAdhaarValid = true;
    }
    if (this.bookingFNIForm.status === 'INVALID') {
      this.disableSubmitButton = false;
      this.formErrorService.displayFormErrors(this.bookingFNIForm);
      this.isProceeding = false;
      return;
    }
    let userdata = {
      data: [
        this.userData.account_type === 'Individual' ? this.bookingFNIForm.value.first_name : this.bookingFNIForm.value.full_name,
        this.userData.account_type === 'Individual' ? this.bookingFNIForm.value.last_name : '.',
        this.bookingFNIForm.value.address1,
        this.bookingFNIForm.value.address2,
      ],
      isBulk: false,
      ignoreTaggedEntities: true,
      domain: 1,
      convertNumber: 'Local',
    };
    this.sub.add(
      this.apiService.getTranslateText(userdata).subscribe({
        next: (response: any) => {
          if (response.responseList[0].apiStatus == 2) {
            this.translatedFirstName = response.responseList[0].outString[0];
            this.translatedLastName = response.responseList[1].outString[0];
            this.translatedAddress1 = response.responseList[2].outString[0];
            this.translatedAddress2 = response.responseList[3].outString[0];
            if (this.typeOfBooking === 'FinanceJourney' || this.typeOfBooking === 'FinanceJourneyNonOsp') {
              this.fni_journeyCreatelead();
            }
            else{
              this.bookVehicleFinance();
            }
          }
        },
        error: () => {
          this.isProceeding = false;
          // this.translatedFirstName =
          //   this.CommonService.replaceUnicode(
          //     this.bookingFNIForm.value.first_name
          //   ) == ''
          //     ? this.bookingFNIForm.value.first_name
          //     : this.CommonService.replaceUnicode(
          //         this.bookingFNIForm.value.first_name
          //       );
          // this.translatedLastName =
          //   this.CommonService.replaceUnicode(
          //     this.bookingFNIForm.value.last_name
          //   ) == ''
          //     ? this.bookingFNIForm.value.last_name
          //     : this.CommonService.replaceUnicode(
          //         this.bookingFNIForm.value.last_name
          //       );
          this.translatedFirstName = this.bookingFNIForm.value.pan_type === 'Individual' ? this.translatedFirstName = this.bookingFNIForm.value.pan_type === 'Individual' ? this.bookingFNIForm.value.first_name : this.bookingFNIForm.value.full_name// this.CommonService.replaceUnicode(this.bookingFNIForm.value.first_name) == '' ? this.bookingFNIForm.value.first_name : this.CommonService.replaceUnicode(this.bookingFNIForm.value.first_name);
                  : this.bookingFNIForm.value.full_name// this.CommonService.replaceUnicode(this.bookingFNIForm.value.first_name) == '' ? this.bookingFNIForm.value.first_name : this.CommonService.replaceUnicode(this.bookingFNIForm.value.first_name);
                  this.translatedLastName = this.bookingFNIForm.value.pan_type === 'Individual'  ? this.CommonService.replaceUnicode(this.bookingFNIForm.value.last_name) == '' ? this.bookingFNIForm.value.last_name : this.CommonService.replaceUnicode(this.bookingFNIForm.value.last_name) : '.'//this.CommonService.replaceUnicode(this.bookingFNIForm.value.last_name) == '' ? this.bookingFNIForm.value.last_name : this.CommonService.replaceUnicode(this.bookingFNIForm.value.last_name);
          this.translatedAddress1 =
            this.CommonService.replaceUnicode(
              this.bookingFNIForm.value.address1
            ) == ''
              ? this.bookingFNIForm.value.address1
              : this.CommonService.replaceUnicode(
                  this.bookingFNIForm.value.address1
                );
          this.translatedAddress2 =
            this.CommonService.replaceUnicode(
              this.bookingFNIForm.value.address2
            ) == ''
              ? this.bookingFNIForm.value.address2
              : this.CommonService.replaceUnicode(
                  this.bookingFNIForm.value.address2
                );
                if (this.typeOfBooking === 'FinanceJourney' || this.typeOfBooking === 'FinanceJourneyNonOsp') {
                  this.fni_journeyCreatelead();
              }
              else{
                this.bookVehicleFinance();
              }
        },
        complete: () => {
          this.isProceeding = false;
        },
      })
    );
  }
  getVehicleDetail() {
    let data;
    if (this.vc) {
      data = {
        vehicle_number: this.vc,
      };
    } else {
      data = {
        product_id: this.productId,
      };
    }
    this.sub.add(
      this.apiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {
          this.productDetailsData = res?.data;
          if (this.dealerCode) {
            this.getDealer();
          }
          if (
            this.VasData &&
            this.VasData?.VCNUMBER !== this.productDetailsData?.vehicle_number
          ) {
            localStorage.removeItem('VASData');
            this.behaviourSubject.vasCreated.next(true);
          }
          if (
            this.productOfferData &&
            this.productOfferData?.vehicle_number !==
              this.productDetailsData?.vehicle_number
          ) {
            localStorage.removeItem('productOfferData');
          }
          // this.totalAmount = this.productDetailsData['down_payment']
            //  this.productDetailsData['down_payment']
          //   : 0;
          if(this.isfnijourney && this.payment_data?.length > 0){
            this.totalAmount = this.payment_data[0]?.amount;
          }else
          {
            this.totalAmount = this.productDetailsData["down_payment"] ? this.productDetailsData["down_payment"] : 0;
          }
             const localDealerCode = localStorage.getItem('dealercd');
            if (localDealerCode) {
              const priceData = {
              dealer_code: localDealerCode || '',
              "vc_number": this.productDetailsData["vehicle_number"] ? this.productDetailsData["vehicle_number"] : ""
            };
             this.getVCPrice(priceData);
            }
          this.quantityChange.emit({
            quantity: this.bookingFNIForm.controls['quantity'].value
              ? this.bookingFNIForm.controls['quantity'].value
              : 1,
            totalAmount: this.totalAmount,
          });
        },
        error: () => {},
        complete: () => {},
      })
    );
  }
 async bookVehicleFinance() {
    this.btndisablefn = true;
    this.ProductQuantity = this.bookingFNIForm.value.quantity;
    // this.totalAmount =
    //   this.productDetailsData['down_payment'] *
    //   this.bookingFNIForm.controls['quantity'].value;
    if(this.isfnijourney && this.payment_data?.length > 0){
      this.totalAmount = (this.payment_data[0]?.amount) * (this.bookingFNIForm.controls['quantity'].value);
    }else
    {
      this.totalAmount = (this.productDetailsData["down_payment"]) * (this.bookingFNIForm.controls['quantity'].value);
    }
    this.quantityChange.emit({
      quantity: this.bookingFNIForm.controls['quantity'].value,
      totalAmount: this.totalAmount,
    });
    let lob = this.productDetailsData.lob;
    let statedata = this.stateList.filter(
      (result) => result.code === this.bookingFNIForm.value.state
    );
    this.dse = [];
    if (this.bookingFNIForm.value.dse && this.dseList?.length > 0) {
      this.dseMatch = false;
      this.dse = [];

      this.dseList.forEach((element) => {
        if (
          element.username?.toLowerCase() ==
          this.bookingFNIForm.value.dse?.toLowerCase()
        ) {
          this.dseMatch = true;
          this.dse = element;
        }
      });
      if (!this.dseMatch) {
        this.toastrService.error(
          'Provided CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin does not match with the dealer.'
        );
      }
    }
    this.encryptAdharNO = this.localStorage.encryptData(
      String(this.bookingFNIForm.value.aadhar)
    );
    let vas_data;
    let data = {
      lead_type: 'FINANCE',
      mm_geography: this.divData[0]?.mm_geography
        ? this.divData[0]?.mm_geography
        : '',
      division_id: this.divData[0]?.division_id
        ? this.divData[0]?.division_id
        : '',
      lob: lob,
      mobile_number: this.bookingFNIForm.value.mobile_number,
      email_id: this.bookingFNIForm.value.email_id,
      first_name: this.translatedFirstName.trim(),
      last_name: this.bookingFNIForm.value.pan_type === 'Individual' ? this.translatedLastName.trim() : '.',
      address_one: this.translatedAddress1.trim(),
      address_two: this.translatedAddress2.trim(),
      state: statedata[0]?.['name'],
      state_code: statedata[0]?.['code'],
      district: String(this.bookingFNIForm.value.district),
      organization_name:
        this.translatedFirstName.trim() +
        this.translatedLastName.trim() +
        this.bookingFNIForm.value.mobile_number,
      vehicle_application: 'NA',
      body_type: 'NA',
      usage_category: '',
      vc_description: this.productDetailsData['product_description']
        ? this.productDetailsData['product_description']
        : '',
      vc_number: this.productDetailsData['vehicle_number']
        ? this.productDetailsData['vehicle_number']
        : '',
      ppl: this.productDetailsData['ppl'] ? this.productDetailsData['ppl'] : '',
      vc_id: this.productDetailsData['vehicle_id']
        ? this.productDetailsData['vehicle_id']
        : '',
      pl: this.productDetailsData['pl'] ? this.productDetailsData['pl'] : '',
      model: this.productDetailsData['model']
        ? this.productDetailsData['model']
        : '',
      quantity: '' + this.bookingFNIForm.value.quantity,
      amc: this.bookingFNIForm.value.AMC,
      lease_interest: this.bookingFNIForm.value.lease_interest,

      is_tml: this.bookingFNIForm.value.is_tml,
      interested_in_exchange: this.bookingFNIForm.value.interested_in_exchange,
      brand: this.bookingFNIForm.value.brand,
      registration_number: this.bookingFNIForm.value.registration_number,
      pi_for_exchange: this.bookingFNIForm.value.pi_for_exchange,
      chassis_number: this.bookingFNIForm.value.chassis_number,
      manufacture_year: this.bookingFNIForm.value.manufacture_year,
      mileage: this.bookingFNIForm.value.mileage,
      action_type:
        this.divData[0]?.payment_details?.length == 0 ? 'Unbilled' : 'Billed',
      // channel: this.isViaConfigurator ? 'OSP_Configurator' : 'Online Booking',
      channel: this.VasData?.isViaOSPVas ? 'Fleet Verse' : (this.isSmart || this.isViaConfigurator) ? 'Fleet Verse Configurator' : 'Fleet Verse',
      "source": this.utmdata ? this.utmdata?.source : '',
      "medium": this.utmdata ? this.utmdata?.medium : '',
      "pan_type": this.bookingFNIForm.value.pan_type,

      // source: this.isDisabled
      //   ? this.dealerCode
      //   : this.utmdata?.source
      //   ? this.utmdata?.source
      //   : '',
      // medium: this.isDisabled
      //   ? 'DealerLandingLink'
      //   : this.utmdata?.medium
      //   ? this.utmdata?.medium
      //   : '',
      campaign: this.utmdata
        ? this.utmdata?.campaign || this.utmdata?.utm_campaignname
        : '',
      campaign_id: this.utmdata ? this.utmdata?.campaign_id : '',
      lead_origin: 'Booking',
      ex_showroom_price: Math.round(this.newVCPriceChange),
      // action_type : !(this.divData[0]?.access_key_id || this.divData[0]?.access_secret_id || this.divData[0]?.account_id )   ? 'Unbilled' : 'Billed'
    };
    data['pan_no'] = this.userData?.pan_no
      ? this.userData?.pan_no
      : String(this.bookingFNIForm.value.panNo);
    // data["aadhar_no"] = this.isAdhaarNoAvailable ? this.isAdhaarNoAvailable
    // : String(this.bookingFNIForm.value.aadhar);
    data['aadhar_number'] = this.encryptAdharNO ? this.encryptAdharNO : '';
    data['taluka'] = this.bookingFNIForm.value.taluka;
    data['city'] = this.bookingFNIForm.value.city;
    data['pincode'] = this.bookingFNIForm.value.pincode
      ? this.bookingFNIForm.value.pincode
      : '';
    (data['finance_account_id'] = this.bookingFNIForm.value.finance.id
      ? this.bookingFNIForm.value.finance.id
      : '1-39ERX-657'),
      (data['finance'] = this.bookingFNIForm.value.finance.name
        ? this.bookingFNIForm.value.finance.name
        : 'SELF');
    data['payment_gateway_type'] =
      this.paymentType == 'ccavenue' ? 'CCAVENUE' : 'RAZORPAY';
    data['dse_first_name'] = this.dseMatch ? this.dse['first_name'] : '';
    data['dse_last_name'] = this.dseMatch ? this.dse['last_name'] : '';
    data['dse_username'] = this.dseMatch ? this.dse['username'] : '';
    this.spinner.show();
    if (this.isVasAvailable) {



      let vasDataArray = [];

      if (Array.isArray(this.VasData.VASPLAN)) {
        vasDataArray = this.VasData.VASPLAN.map((plan,index) => ({
          payment_gateway_type: this.paymentType === "ccavenue" ? "CCAVENUE" : "RAZORPAY",
          vas_category: plan.plan,
          // vas_payble_amount: this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0,
          vas_payble_amount: index === 0 ? (this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0) : 0,
          chassis_number: "",
          vc_number: this.VasData.VCNUMBER,
          application: this.VasData.vasApplication,
          terrian: this.VasData.terrian,
          avg_monthly_km: this.VasData.AnnualKms,
          no_of_years: plan['contract years'] && Number(plan['contract years']) > 0 ? (Number(plan['contract years']) * 12).toString() : (plan['contract years'] === '' ? (1 * 12).toString() : ''),
          // no_of_years: this.VasData.NoOfyears.toString(),
          quantity: "1",
          recommended_quantity: this.VasData?.recommended_quantity ? this.VasData?.recommended_quantity : "1",
          // quantity: plan.number_of_chassis.toString(),
          // channel: this.isSmart || this.VasData ? "OSP_Configurator" : "Online Booking",
          channel: this.VasData?.isViaOSPVas ? 'Fleet Verse' : (this.isSmart || this.isViaConfigurator) ? 'Fleet Verse Configurator' : 'Fleet Verse',
          fuel_type: this.VasData.fuel_type || this.productDetailsData.fuel_type,
          // is_vas_recommendation:true
          is_amc: index === 0 ? true : false,
          // ...(plan.is_vas_recommendation ? { "is_vas_recommendation": plan.is_vas_recommendation } : {})
        }));
        data['is_vas_recommendation'] = true;
      } else
      {
        vasDataArray = [{
         "payment_gateway_type": this.paymentType == "ccavenue" ? "CCAVENUE" : "RAZORPAY",
        "vas_category": this.VasData.VASPLAN,
        "vas_payble_amount": this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0,
        "chassis_number": "",
        "vc_number": this.VasData.VCNUMBER,
        "application": this.VasData.vasApplication,
        "terrian": this.VasData.terrian,
        "avg_monthly_km": this.VasData.AnnualKms,
        "no_of_years": (this.VasData.NoOfyears).toString(),
        "quantity": "1",
        "recommended_quantity": this.VasData?.recommended_quantity ? this.VasData?.recommended_quantity : "1",
        // "channel": this.VasData ? 'OSP_Configurator' : 'Online Booking',
      // channel: this.isSmart || this.VasData ? 'OSP_Configurator' : 'Online Booking',
      channel: this.VasData?.isViaOSPVas ? 'Fleet Verse' : (this.isSmart || this.isViaConfigurator) ? 'Fleet Verse Configurator' : 'Fleet Verse',
        "fuel_type": this.VasData.fuel_type ? this.VasData.fuel_type : this.productDetailsData.fuel_type,
        ...(this.VasData.is_amc ? { "is_amc": this.VasData.is_amc } : {})
        }];

      }

      data['vas_data'] = vasDataArray;
    }
    data['stock'] = this.stock;

    if (data.organization_name?.length > 50) {
      data['organization_name'] =
        this.translatedFirstName.trim() +
        this.bookingFNIForm.value.mobile_number;
    }
    if (data.organization_name?.length > 50) {
      data['organization_name'] =
        this.translatedFirstName.trim().substring(0, 39) +
        this.bookingFNIForm.value.mobile_number;
    }
    this.clevertap(statedata[0]?.['name']);
    if (this.productOfferData) {
      data['fni_account_id'] = this.productOfferData
        ? this.productOfferData?.financierId
        : this.bookingFNIForm.value.finance.id
        ? this.bookingFNIForm.value.finance.id
        : '1-39ERX-657';
    }
    this.sub.add(
      this.apiService.generateLead(data).subscribe({
        next: async (response: any) => {
          if (response.success) {
            let id = localStorage.getItem('tat_id');
            if (id !== null && id !== undefined) {
            try {
              await this.vastatrequestresponsereturn(response?.data?.lead_info?.row_id); // Wait for API response
            } catch (error) {
              console.error("Error in vastatrequestresponse:", error);
            }
          }
            var unxPayload = [
              {
                pid: this.productDetailsData.vehicle_number.toString(),
                variantId: this.productDetailsData.vehicle_number, // Only if variant is present
                qty: String(this.bookingFNIForm.value.quantity),
                price: this.productDetailsData.price_range.toString(),
              },
            ];

            unbxUrl.fireUnbxdOrder(unxPayload);
            if (data['pan_no'] && !this.isPanVerified) {
              this.uploadKyc(false);
            } else if (
              this.bookingFNIForm.controls['aadhar'].value?.length >= 12 &&
              !this.isAdhaarVerified
            ) {
              this.uploadKyc(false);
            } else {
            }
            if (isPlatformBrowser(this.platformId)) {
              localStorage.removeItem('participant');
            }
            this.reqID = response['data'].lead_info.row_id;
            const schemeValue = localStorage.getItem('schemeDetails');
            const storedSchemeCode = localStorage.getItem('schemeCode');

            const accumulationData = {
              mobile_number: this.userData.mobile_number,
              source: "OSP",
              order_number: response["data"].lead_info.row_id,
              scheme_code: storedSchemeCode,
              // status: "Completed",
              action_type: "add",
            };

            // this.userAaccumulation(accumulationData)
            // const dealercd = localStorage.getItem('dealercd');

            // let dealerCode = this.schemeDealeCodes.includes(dealercd) ? true : false
            if (storedSchemeCode) {
              this.userAaccumulation(accumulationData)
            }
            this.getOptyID(
              response['data'].lead_info.row_id,
              response.data.msg
            );
          } else {
            this.btndisablefn = false;
            this.spinner.hide();
            this.disableSubmitButton = false;
            if (
              response.data.msg ===
                'You already have an active request in Tata Motors system.' ||
              response.data.msg ===
                'You already have active request against this vehicle. Please visit My Booking Request section in Profile to complete the process.'
            ) {
              this.errormessagefni = response.data.msg;
              $('#popuperrorfni').modal('show');
            } else {
              this.toastrService.warning(response.data.msg);
            }
            this.isProcess = false;
          }
        },
        error: () => {
          if (isPlatformBrowser(this.platformId)) {
            this.toastrService.warning(
              'Something went wrong, Please try again !'
            );
            this.spinner.hide();
          }
        },
        complete: () => {},
      })
    );
  }
  get_inventory_detail(dealerCode?) {
    let data = {
      vc_number: this.productDetailsData.vehicle_number,
      dealer_code: dealerCode,
    };
    this.sub.add(
      this.apiService.getinventorydetails(data).subscribe({
        next: (response: any) => {
          if (response.quantity) {
            this.stock = response.quantity;
          } else {
            this.stock = 0;
          }
        },
      })
    );
  }
  getOptyID(reqId, showMsg?) {
    let reqData = {
      request_id: reqId,
    };

    this.sub.add(
      this.apiService.getOptyStatus(reqData).subscribe({
        next: (response: any) => {
          this.isOptyFailed = response.data?.status;
          this.fniOpty = response.data.opty_id;
          this.fniOptyStatus = response.data.opty_status;
          this.fniBegin = response.data.fni_begin;
        },
        error: () => {
          localStorage.removeItem('productOfferData');
          this.spinner.hide();
          this.router.navigate(['account/booking']);
        },
        complete: () => {
          let timer = 10000;
          if (this.isOptyFailed == 'Failed') {
            this.spinner.hide();
            this.toastrService.warning(
              'Due to some technical issue the opty is not created. please try again later '
            );

            localStorage.removeItem('productOfferData');
            this.router.navigate(['account/booking']);
          } else {
            if (this.apiCount >= 20) {
              if (this.apiCount == 1) {
                this.spinner.hide();
                this.toastrService.success(showMsg);
              }
              this.spinner.hide();

              localStorage.removeItem('productOfferData');
              this.router.navigate(['account/booking']);
            } else {
              this.apiCount = 1 + this.apiCount;

              setTimeout(() => {
                this.getOptyID(this.reqID);
                if (this.fniBegin) {
                  this.spinner.hide();
                  let data = {
                    appName: 'com.tatamotors.cv_online_portal',
                    crmOpportunityID: this.fniOpty,
                  };
                  this.sub.add(
                    this.apiService.getfniToken(data).subscribe({
                      next: (data: any) => {
                        if (data?.challengeToken) {
                          this.spinner.hide();
                          localStorage.removeItem('productOfferData');
                          this.localStorage.setItem(
                            'productVehicleImgUrl',
                            JSON.stringify(
                              this.productDetailsData?.images[0]?.image_url
                                ? this.productDetailsData?.images[0]?.image_url
                                : 'https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/placeholder.webp'
                            )
                          );
                          this.router.navigate(['/fni/application-overview'], {
                            queryParams: {
                              login_id: this.bookingFNIForm.value.mobile_number,
                              opty_id: this.fniOpty,
                              token: data?.challengeToken,
                            },
                          });
                        } else {
                          this.spinner.hide();
                          this.toastrService.warning(data?.message);
                        }
                      },
                      error: () => {
                        localStorage.removeItem('productOfferData');
                        this.spinner.hide();
                        this.router.navigate(['account/booking']);
                      },
                    })
                  );
                }
              }, timer);
            }
          }
        },
      })
    );
  }
  resetWizard() {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }
  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }

  // onFocusOutRemoveSpaceFirstName(event: any) {
  //   let value = event.target.value.replace(/\s/g, '');
  //   this.bookingFNIForm.patchValue({ first_name: value });
  // }
  // onFocusOutRemoveSpace(event: any) {
  //   let value = event.target.value.replace(/\s/g, '');
  //   this.bookingFNIForm.patchValue({ last_name: value });
  // }

  addressByPincode() {
    this.stateList = [];
    this.districtList = [];
    this.cityList = [];
    this.talukaList = [];
    this.bookingFNIForm.patchValue({
      state: '',
      district: '',
      city: '',
      taluka: '',
    });
    if (this.bookingFNIForm.value.pincode?.length == 6) {
      this.getAddress(this.bookingFNIForm.value.pincode);
      this.onChangeDistrict();
    }
  }

  getAddress(pincode: any) {
    let data = {
      pincode: pincode,
      app_name: 'com.tatamotors.cvonline',
      device_id: '1234',
    };
    this.sub.add(
      this.apiService.getAddressByPincodeList(data).subscribe({
        next: (response: any) => {
          if (response) {
            this.cityList = [];
            this.stateList = [];
            this.talukaList = [];
            this.districtList = [];

            if (response?.length > 1) {
              this.address = response;
              this.talukaList = Array.from(
                new Set(this.address.map((obj) => obj.taluka))
              );
              this.stateList = Array(response[0]?.state);
              this.districtList = Array(response[0]?.district?.toLowerCase());
              // this.address.forEach(element => {
              //   this.cityList.push(element.city)
              // });
              this.onTalukaSelect(this.talukaList[0]);
              this.bookingFNIForm.patchValue({
                district: this.districtList,
                state: this.stateList[0]?.code,
                taluka: this.talukaList[0],
              });
              this.disabledCity = true;
              this.resetForm('dse');
            } else {
              this.address = response;
              this.stateList = Array(this.address[0]?.state);
              this.districtList = Array(
                this.address[0]?.district?.toLowerCase()
              );
              this.cityList.push(this.address[0]?.city);
              this.talukaList.push(this.address[0]?.taluka?.toLowerCase());
              this.bookingFNIForm.patchValue({
                district: this.districtList,
                state: this.stateList[0]?.code,
                city: this.cityList[0],
                taluka: this.talukaList[0],
              });
              this.disabledCity = false;
            }
            this.onChangeDistrict();
          }
          if (response.apierror) {
            this.toastrService.warning(
              'Address not found for pincode provided'
            );
            this.bookingFNIForm.patchValue({
              district: '',
              state: '',
              city: '',
              taluka: '',
            });
            this.stateList = [];
            this.districtList = [];
            this.talukaList = [];
            this.cityList = [];
          }
        },
      })
    );
  }

  onTalukaSelect(val) {
    this.cityList = [];
    for (let i = 0; i < this.address?.length; i++) {
      if (val == this.address[i].taluka) {
        this.cityList.push(this.address[i].city);
      }
    }
  }

  checkKYC() {
    if (this.bookingFNIForm.controls['panNo'].value.Invalid) {
      this.toastrService.warning('Invalid format of Pan Number');
    } else if (this.bookingFNIForm.controls['aadhar'].value.Invalid) {
      this.toastrService.warning('Invalid format of Adhaar Card Number');
    }

    var kfcJson = {
      pan: this.bookingFNIForm.controls['panNo'].value,
      aadhaarLastFour: this.bookingFNIForm.controls['aadhar'].value.substr(
        this.bookingFNIForm.controls['aadhar'].value?.length - 4
      ),
      dob: '',
      name: '',
      address: '',
      getContactDetails: 'N',
      PANStatus: 'Y',
      isSalaried: 'N',
      isDirector: 'N',
      isSoleProp: 'N',
      fathersName: 'N',
      consent: 'Y',
      clientData: {
        caseId: '123456',
      },
    };
    this.spinner.show();
    try {
      this.sub.add(
        this.apiService.checkkyc(kfcJson).subscribe({
          next: (res: any) => {
            if (res.success) {
              if (res.data.result) {
                this.kycKarzaRes = res.data.result;
                if(this.bookingFNIForm.value.pan_type === 'Individual'){               
                  this.bookingFNIForm.controls['first_name'].setValue(res.data.result.firstName);
                  this.bookingFNIForm.controls['last_name'].setValue(res.data.result.lastName);
                } else{  
                  this.bookingFNIForm.controls['full_name'].setValue(res.data.result.name);
                }
                // if (Object.keys(res.data.result)?.length !== 0) {
                //   if (res.data.result?.aadhaarMatch == true) {
                //     if (
                //       this.CommonService.replaceUnicode(
                //         this.bookingFNIForm.controls['first_name'].value.trim()
                //       )?.toLowerCase() ===
                //       res.data.result?.firstName?.toLowerCase()
                //     ) {
                //       if (!this.isAdhaarVerified || !this.isPanVerified) {
                //         this.uploadKyc();
                //       }
                //       this.toastrService.success('KYC Done Successfully');
                //     } else {
                //       this.spinner.hide();
                //       this.toastrService.warning(
                //         'Name Not Matching With Pan Card'
                //       );
                //       return;
                //     }
                //   } else {
                //     this.spinner.hide();
                //     this.toastrService.warning('Aadhaar number is incorrect.');
                //     return;
                //   }
                // } 
                // 
                if (Object.keys(res.data.result).length !== 0) {
                  if (res.data.result?.aadhaarMatch == true) {
  
                    if (((this.bookingFNIForm.controls['first_name'].value.trim()).toLowerCase() === res.data.result?.firstName.toLowerCase()) && this.bookingFNIForm.value.pan_type === 'Individual') {
                      if (!this.isAdhaarVerified || !this.isPanVerified ) {
  
                        this.uploadKyc(true)
                      }
                      this.toastrService.success("KYC Done Successfully")
                    }
                    else {
                      this.spinner.hide()
                      this.toastrService.warning("Name Not Matching With Pan Card")
                      return
                    }
                  } else  if (res.data.result?.aadhaarMatch == null) {
                    if(((this.bookingFNIForm.controls['full_name'].value.trim()).toLowerCase() === res.data.result?.name.toLowerCase()) && this.bookingFNIForm.value.pan_type === 'Company') {
                    if (!this.isPanVerified ) {
  
                      this.uploadKyc(false)
                    }
                    else{
                      this.spinner.hide()
                      this.toastrService.warning("Name Not Matching With Pan Card")
                      return
                    }
                  }
                  }
                  else {
                    this.spinner.hide()
                    this.toastrService.warning("Aadhaar number is incorrect.")
                    return
                  }
                }
              }
            } else {
              this.spinner.hide();
              this.toastrService.warning(res.data.msg);
            }
          },
          error: () => {
            this.spinner.hide();
          },
        })
      );
    } catch (error) {
      this.spinner.hide();
    }
  }
  uploadKyc(iskyc?) {
    let req;
    if (!this.isAdhaarVerified && this.isPanVerified && this.bookingFNIForm.value.pan_type === 'Individual') {
      req = {
        address_proofs: [
          {
            data: '',
            document_type: 'Address Proof',
            document_description: 'aadhar_card',
            doc_number: this.bookingFNIForm.controls['aadhar'].value,
            'e-KYC': iskyc,
          },
        ],
      };
    } else if (!this.isPanVerified && this.isAdhaarVerified && this.bookingFNIForm.value.pan_type === 'Individual') {
      req = {
        id_proofs: [
          {
            data: '',
            document_type: 'ID Proof',
            document_description: 'id_pancard',
            doc_number: this.bookingFNIForm.controls['panNo'].value,
            'e-KYC': iskyc,
          },
        ],
      };
    } else if(this.bookingFNIForm.value.pan_type === 'Individual') {
      if (
        !this.isPanVerified && !this.isAdhaarVerified  && this.bookingFNIForm.value.pan_type === 'Individual'
      ) {
        req = {
          address_proofs: [
            {
              data: '',
              document_type: 'Address Proof',
              document_description: 'aadhar_card',
              doc_number: this.bookingFNIForm.controls['aadhar'].value,
              'e-KYC': iskyc,
            },
          ],
          id_proofs: [
            {
              data: '',
              document_type: 'ID Proof',
              document_description: 'id_pancard',
              doc_number: this.bookingFNIForm.controls['panNo'].value,
              'e-KYC': iskyc,
            },
          ],
        };
      }
    }else{
      req = {
        id_proofs: [
          {
            data: '',
            document_type: 'ID Proof',
            document_description: 'id_pancard',
            doc_number: this.bookingFNIForm.controls['panNo'].value,
            'e-KYC': iskyc,
          },
        ],
      };
    }
    try {
      this.sub.add(
        this.apiService.uploadKYC(req).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.updateUserAddress();
            } else {
              this.toastrService.warning(res.data.msg);
            }
          },
          error: () => {},
          complete: () => {},
        })
      );
    } catch (error) {}
  }
  updateUserAddress() {
    let karzaRes = this.kycKarzaRes?.address;
    var userAddrss = karzaRes
      ? karzaRes.buildingName +
        ',' +
        karzaRes.streetName +
        ',' +
        karzaRes.locality
      : this.CommonService.replaceUnicode(this.userData?.address_one);
    let data = {
      id: this.userData.id,
     "first_name": this.userData.account_type === 'Individual' ? this.CommonService.replaceUnicode(this.bookingFNIForm.controls['first_name'].value.trim()) : this.CommonService.replaceUnicode(this.bookingFNIForm.controls['full_name'].value.trim()),
      "last_name": this.userData.account_type === 'Individual' ? this.CommonService.replaceUnicode(this.bookingFNIForm.controls['last_name'].value.trim()) : '.',
      email_id: this.bookingFNIForm.controls['email_id'].value.trim(),
      address_one: this.CommonService.replaceUnicode(userAddrss),
      "account_type": this.bookingFNIForm.value.pan_type ? this.bookingFNIForm.value.pan_type :'',
    };
    try {
      this.sub.add(
        this.apiService.updateCustomer(data).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.getUserDetails();
              // this.spinner.hide()
            } else {
              this.toastrService.warning(res.data.msg);
              // this.spinner.hide()
            }
          },
          error: () => {
            // this.spinner.hide()
          },
        })
      );
    } catch (error) {
      this.spinner.hide();
    }
  }
  async onChangeDistrict() {
    this.divData = [];
    this.divisions = [];
    if (
      this.bookingFNIForm.get('district').valid &&
      this.bookingFNIForm.get('state').valid
    ) {
      let data = {
        district: String(this.bookingFNIForm.get('district').value),
        state: this.bookingFNIForm.get('state').value,
        lob_name: this.productDetailsData.lob
          ? this.productDetailsData.lob
          : '',
        vc: this.productDetailsData.vehicle_number,
      };
      this.sub.add(
        this.apiService.getDealerList(data).subscribe({
          next: (response: any) => {
            if (response.success) {
              if (this.fni_dealercode) {
                this.divisions = [];
                response['data'].forEach((res) => {
                  this.divisions.push(res);
                });
                let final = [];
                // if( this.financeDealerCode?.length > 0){
                this.divisions.forEach((element) => {
                  if (this.fni_dealercode == element.dealer_code) {
                    this.financeDealerCode = final.push(element);
                  }
                  // });
                });
                if (
                  final?.length == 0 &&
                  this.emptyDealer &&
                  this.financeDealerCode?.length > 0
                ) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error(
                    'Provided dealer do not serve in this area '
                  );
                  return;
                }
                if (final?.length == 0 && !this.emptyDealer) {
                  this.divisions = final;
                  this.resetForm('division_id');
                  this.toastrService.error(
                    'Provided dealer do not serve in this area '
                  );
                  return;
                }
                if (final?.length > 0) {
                  this.divisions = final;
                  if (final?.length == 1 && this.fni_dealercode) {
                    this.bookingFNIForm.patchValue({
                      division_id: this.divisions[0]?.division_id,
                    });
                  }
                  this.setDivision();
                }
              } else {
                this.divisions = [];
                response['data'].forEach((res) => {
                  this.divisions.push(res);
                });
                let final = [];
                if (response['data']?.length == 1 && this.dealerCode) {
                  this.bookingFNIForm.patchValue({
                    division_id: this.divisions[0]?.division_id,
                  });
                  this.setDivision();
                }

                if (this.dealerCode) {
                  // if( this.financeDealerCode?.length > 0){
                  this.divisions.forEach((element) => {
                    if (this.dealerCode == element.dealer_code) {
                      this.financeDealerCode = final.push(element);
                    }
                    // });
                  });
                  if (
                    final?.length == 0 &&
                    this.emptyDealerFni &&
                    this.financeDealerCode?.length > 0
                  ) {
                    this.divisions = final;
                    this.resetForm('division_id');
                    this.toastrService.error(
                      'Provided dealer do not serve in this area '
                    );
                    return;
                  }
                  if (final?.length == 0 && !this.emptyDealerFni) {
                    this.divisions = final;
                    this.resetForm('division_id');
                    this.toastrService.error(
                      this.dealername[0].division_name +
                        ' do not serve in this area '
                    );
                    return;
                  }
                  if (final?.length > 0) {
                    this.divisions = final;
                    if (final?.length == 1 && this.dealerCode) {
                      this.bookingFNIForm.patchValue({
                        division_id: this.divisions[0]?.division_id,
                      });
                    }
                    this.setDivision();
                  }
                  // }
                  else {
                  }
                } else {
                  this.setDivision();
                }
              }
            } else {
              this.toastrService.warning(response?.data?.msg);
            }
          },
        })
      );
    } else {
      this.divisions = [];
    }
  }
  resetForm(value: any) {
    this.bookingFNIForm.controls[value].setValue('');
    this.bookingFNIForm.get(value).updateValueAndValidity();
  }
  getVCPrice(data) {
    this.sub.add(
      this.apiService.getDealerPrice(data).subscribe({
        next: (response: any) => {
          this.VCPriceChange.emit({
            newVCPrice: response?.data?.dealer_price
              ? response.data.dealer_price
              : null,
          });
          this.newVCPriceChange = response?.data?.dealer_price;
        },
        error: () => {},
        complete: () => {},
      })
    );
  }
  setDivision() {
    this.resetForm('dse');

    this.divData = this.divisions.filter(
      (division) =>
        division.division_id == this.bookingFNIForm.value.division_id
    );
 const localDealerCode = localStorage.getItem('dealercd');
   if (!localDealerCode) {
    let priceData = {
      dealer_code: this.divData[0]?.dealer_code,
      vc_number: this.productDetailsData['vehicle_number']
        ? this.productDetailsData['vehicle_number']
        : '',
    };
    this.getVCPrice(priceData);
  }
    if (this.bookingFNIForm.value.division_id) {
      this.divData = this.divisions.filter(
        (division) =>
          division.division_id == this.bookingFNIForm.value.division_id
      );
      this.bookingFNIForm.patchValue({
        division_id: this.divData[0]?.division_id,
      });

      if (this.divData?.length == 0) {
      }
    } else {
      this.divData = this.divisions.filter(
        (division) =>
          division.division_id == this.bookingFNIForm.value.division_id
      );
    }
    if (this.divData?.length == 0) {
      this.bookingFNIForm.patchValue({ division_id: '' });
    } else {
      this.bookingFNIForm.patchValue({
        division_id: this.divData[0]?.division_id,
      });
    }
    if (this.divData[0]?.payment_details?.length > 1) {
      if (this.isVasAvailable && this.isViaConfigurator) {
        this.divData[0].payment_details.forEach((element: any) => {
          if (element.payment_gt_type == 'RAZORPAY') {
            this.paymentType = 'ccavenue';
            return;
          }
        });
      } else {
        this.paymentType = 'razorpay';
      }
    } else {
      if (
        this.isVasAvailable &&
        this.isViaConfigurator &&
        this.divData[0]?.payment_details?.length == 1
      ) {
        this.divData[0].payment_details.forEach((element: any) => {
          if (element.payment_gt_type == 'RAZORPAY') {
            this.paymentType = 'razorpay';
            return;
          } else {
            this.paymentType = 'ccavenue';
            return;
          }
        });
      } else {
        if (
          !this.isVasAvailable &&
          !this.isViaConfigurator &&
          this.divData[0]?.payment_details?.length == 1
        ) {
          this.divData[0].payment_details.forEach((element: any) => {
            if (element.payment_gt_type == 'RAZORPAY') {
              this.paymentType = 'razorpay';
              return;
            } else {
              this.paymentType = 'ccavenue';
              return;
            }
          });
        }
        if (
          !this.isVasAvailable &&
          this.isViaConfigurator &&
          this.divData[0]?.payment_details?.length == 1
        ) {
          this.divData[0].payment_details.forEach((element: any) => {
            if (element.payment_gt_type == 'RAZORPAY') {
              this.paymentType = 'razorpay';
              return;
            } else {
              this.paymentType = 'ccavenue';
              return;
            }
          });
        }
      }
    }
    if (this.divData[0] && this.isViaConfigurator) {
      this.getVehicleEdd();
      this.get_inventory_detail(this.divData[0]?.dealer_code);
    }
    this.bookingFNIForm.patchValue({ bookingAmount: 'No' });
    this.getDseList();
  }
  async getDseList() {
    {
      this.dseList = [];

      let code;
      let divisionId = this.divData[0]?.division_id;
      this.divisions.forEach((res) => {
        if (res.division_id == divisionId) {
          code = res.dealer_code;
        }
      });

      this.dseList = [];

      let data = {
        lob: this.productDetailsData.lob,
        dealer_code: code,
        division_id: code ? divisionId : ""
      };
      this.sub.add(
        this.apiService.getDSEList(data).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.dseList = response.data;
            } else {
              this.dseList = [];
            }
          },
        })
      );
    }
  }

  getVehicleEdd() {
    let data = {
      vc: this.productDetailsData?.vehicle_number,
      dealer_code: this.divData[0]?.dealer_code,
    };
    this.sub.add(
      this.apiService.getVehicleEddData(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.dealerData.emit({
              dealerDataList: response.data ? response.data : null,
            });
          }
        },
      })
    );
  }
  onCheckboxChange(checked: boolean) {
    if (checked) {
      this.checkBoxcheked=true
    } else {
      this.checkBoxcheked=false
    }
  }

  async getDealer() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('dealername');
      {
        let data = {
          lob_name: this.productDetailsData.lob,
          dealer_code: this.dealerCode,
          action_type: 'dropdown',
        };
        this.sub.add(
          this.apiService.getDealerList(data).subscribe({
            next: (response: any) => {
              if (response.success) {
                this.dealername = response?.data;
                localStorage.setItem(
                  'dealername',
                  this.dealername[0].division_name +
                    '_' +
                    this.dealername[0].dealer_code
                );
                this.behaviourSubject.dealerName.next(true);
              } else {
                this.financeDealerCode = [];
                this.disableSubmitButton = false;
                this.divisions = [];
                this.disableFields = false;
                this.emptyDealer = true;
              }
            },
            error: (error) => {
              this.toastrService.warning(error.data.msg);
            },
            complete: () => {},
          })
        );
      }
    }
  }

  clevertap(state: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onFinanceInitiated(
          this.CommonService.replaceUnicode(
            this.bookingFNIForm.value.first_name
          ),
          this.CommonService.replaceUnicode(
            this.bookingFNIForm.value.last_name
          ),
          this.bookingFNIForm.value.mobile_number,
          this.bookingFNIForm.value.email_id,
          state,
          this.bookingFNIForm.value.city,
          this.bookingFNIForm.value.district,
          this.bookingFNIForm.value.taluka,
          this.bookingFNIForm.value.pincode,
          this.divData[0].division_name,
          '',
          this.bookingFNIForm.value.quantity,
          this.productDetailsData['id'],
          this.productDetailsData['model'],
          this.productDetailsData?.images[0]?.image_url,
          this.productDetailsData['sub_lob'],
          this.productDetailsData['lob'],
          this.productDetailsData['ppl'],
          this.productDetailsData['price_range']
            ? this.productDetailsData['price_range']
            : '',
          this.productDetailsData['down_payment'],
          '',
          '',
          '',
          '',
          this.dseMatch ? this.dse['username'] : ''
        );
      } catch {}
    }
  }
  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.sub.unsubscribe();
    }
  }

  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.bookingFNIForm);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingFNIForm);
  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingFNIForm);
  public hasMaxLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingFNIForm);

  public hasRequiredErrorDesc = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.bookingFNIForm);
  public hasPatternErrorDesc = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingFNIForm);
  public hasMinLengthErrorDesc = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingFNIForm);

  getPanValue(data:any){
    let pan=this.panInput.nativeElement.value;

    if (this.bookingFNIForm.value.pan_type === 'Individual' && pan[3]!=='P' && pan.length>3) {
      this.checkPan=true
    }
    else if (this.bookingFNIForm.value.pan_type === 'Company' && pan[3] ==='P' && pan.length>3) {
      this.checkPan=true
    }
    else{
      this.checkPan=false
    }
  }
  getPanVal(data:any){
    let data1=data.target.value
    let pan=this.panInput.nativeElement.value;
    // const panRegex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
    // && panRegex.test(pan)
    if (data1.length == 10 ) {
      if (this.bookingFNIForm.value.pan_type === 'Individual' && pan[3]!=='P') {
        this.checkPan=true
      } else if(pan[3]==='P' &&this.bookingFNIForm.value.pan_type === 'Company'){
        this.checkPan=true
      }
      else{
        this.checkPan=false
      }
    }
    else{
      this.checkPan=false
    }
  }
  toUpperCase(event: Event): void {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    input.value = input.value.toUpperCase();
    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }
  }
  preventTab(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
  }
  getOptyData(data: any, offset: any) {
    let payload = {
      opty_id: data,
      dealer_code: this.dealerCode,
      offset: offset,
      limit: 10,
    };
    this.spinner.show();
    this.sub.add(
      this.apiService.getFindOpty(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.fniUserData = res.data;
            this.fniUserData = this.fniUserData[0];
            this.getUserDetails();

            this.spinner.hide();
          } else {
            this.toastrService.warning(res.data.msg);
            this.spinner.hide();
          }
        },
        error: (err) => {},
        complete: () => {},
      })
    );
  }
  getleadData(data: any) {
    let payload = {
      offset: 0,
      size: 10,
      lead_type: 'BOOKING',
      opty_id: data,
    };
    this.spinner.show();
    this.sub.add(
      this.apiService.getLeads(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.fniOspGetlead = res?.data?.leads;
            this.fniOspGetlead = this.fniOspGetlead[0];
            this.usefniLead = res?.data?.user;

            this.getUserDetails();

            this.spinner.hide();
          } else {
            this.toastrService.warning(res.data.msg);
            this.spinner.hide();
          }
        },
        error: (err) => {},
        complete: () => {},
      })
    );
  }
  fni_journeyCreatelead() {

    this.encryptPanNOFni = this.localStorage.encryptData(
      String(this.bookingFNIForm.value.panNo)
    );
    this.encryptAdharNOFni = this.localStorage.encryptData(
      String(this.bookingFNIForm.value.aadhar)
    );
    let lob = this.productDetailsData.lob;
    let statedata = this.stateList.filter(
      (result) => result.code === this.bookingFNIForm.value.state
    );
    let panType = this.bookingFNIForm.value.pan_type

    let payLoad = {
      lead_type: 'FINANCE',
      mm_geography: this.divData[0]?.mm_geography
        ? this.divData[0]?.mm_geography
        : '',
      // "division_id": this.divData[0]?.division_id ? this.divData[0]?.division_id : "",
      division_id:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.DIV_ID_s
            ? this.fniUserData?.DIV_ID_s
            : ''
          : this.fniOspGetlead?.division_id
          ? this.fniOspGetlead?.division_id
          : '',
      lob: lob,
      mobile_number:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CONTACT_CELL_PH_NUM_s
            ? this.fniUserData?.PR_CONTACT_CELL_PH_NUM_s
            : ''
          : this.bookingFNIForm.value.mobile_number
          ? this.bookingFNIForm.value.mobile_number
          : '',
      email_id: this.bookingFNIForm.value.email_id
        ? this.bookingFNIForm.value.email_id
        : '',
     "first_name":panType == 'Individual' ? (this.typeOfBooking === 'FinanceJourneyNonOsp' ? (this.fniUserData?.PR_CONTACT_FST_NAME_s ? this.fniUserData?.PR_CONTACT_FST_NAME_s:'' ): (this.translatedFirstName.trim() ? this.translatedFirstName.trim() : '')):(this.bookingFNIForm.value.full_name),
  "last_name":panType == 'Individual' ? (this.typeOfBooking === 'FinanceJourneyNonOsp' ? (this.fniUserData?.PR_CONTACT_LAST_NAME_s ? this.fniUserData?.PR_CONTACT_LAST_NAME_s:'') : (this.translatedLastName ? this.translatedLastName.trim() : '.')):('.'),
  'pan_type': this.bookingFNIForm.value.pan_type ? this.bookingFNIForm.value.pan_type : "",
      address_one: this.translatedAddress1.trim()
        ? this.translatedAddress1.trim()
        : '',
      address_two: this.translatedAddress2.trim()
        ? this.translatedAddress2.trim()
        : '',
      state: statedata[0]?.['name'] ? statedata[0]?.['name'] : '',
      state_code: statedata[0]?.['code'] ? statedata[0]?.['code'] : '',
      district: String(this.bookingFNIForm.value.district)
        ? String(this.bookingFNIForm.value.district)
        : '',
      organization_name:
        this.translatedFirstName.trim() +
        this.translatedLastName.trim() +
        this.bookingFNIForm.value.mobile_number,
      body_type: 'NA',
      usage_category: '',
      vc_description: this.productDetailsData['product_description']
        ? this.productDetailsData['product_description']
        : '',
      vc_number: this.productDetailsData['vehicle_number']
        ? this.productDetailsData['vehicle_number']
        : '',
      ppl: this.productDetailsData['ppl'] ? this.productDetailsData['ppl'] : '',
      vc_id: this.productDetailsData['vehicle_id']
        ? this.productDetailsData['vehicle_id']
        : '',
      pl: this.productDetailsData['pl'] ? this.productDetailsData['pl'] : '',
      quantity: '' + this.bookingFNIForm.value.quantity,
      amc: this.bookingFNIForm.value.AMC ? this.bookingFNIForm.value.AMC : '',
      lease_interest: this.bookingFNIForm.value.lease_interest
        ? this.bookingFNIForm.value.lease_interest
        : '',
      finance_account_id: this.bookingFNIForm.value.finance.id
        ? this.bookingFNIForm.value.finance.id
        : '1-39ERX-657',
      finance: this.bookingFNIForm.value.finance.name
        ? this.bookingFNIForm.value.finance.name
        : 'SELF',
      model: this.productDetailsData['model']
        ? this.productDetailsData['model']
        : '',
      is_tml: 'True',
      interested_in_exchange: this.bookingFNIForm.value.interested_in_exchange
        ? this.bookingFNIForm.value.interested_in_exchange
        : '',
      brand: this.bookingFNIForm.value.brand
        ? this.bookingFNIForm.value.brand
        : '',
      registration_number: this.bookingFNIForm.value.registration_number
        ? this.bookingFNIForm.value.registration_number
        : '',
      pi_for_exchange: this.bookingFNIForm.value.pi_for_exchange
        ? this.bookingFNIForm.value.pi_for_exchange
        : '',
      chassis_number: this.bookingFNIForm.value.chassis_number
        ? this.bookingFNIForm.value.chassis_number
        : '',
      manufacture_year: this.bookingFNIForm.value.manufacture_year
        ? this.bookingFNIForm.value.manufacture_year
        : '',
      mileage: this.bookingFNIForm.value.mileage
        ? this.bookingFNIForm.value.mileage
        : '',
      action_type:
        this.divData[0]?.payment_details?.length == 0 ? 'Unbilled' : 'Billed',
      source: '',
      medium: '',
      campaign: this.utmdata
        ? this.utmdata?.campaign || this.utmdata?.utm_campaignname
        : '',
      campaign_id: this.utmdata ? this.utmdata?.campaign_id : '',
      lead_origin: 'Booking',
      ex_showroom_price: Math.round(this.newVCPriceChange),
      payment_gateway_type:
        this.paymentType == 'ccavenue' ? 'CCAVENUE' : 'RAZORPAY',
      down_payment:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.payment_info?.length > 0
            ? this.fniUserData?.payment_info?.amount
            : this.fniUserData?.vehicles_info?.down_payment *
              this.fniUserData?.INIT_QUANTITY_s
          : this.typeOfBooking == 'FinanceJourney'
          ? this.fniOspGetlead?.payment_info?.length > 0
            ? this.fniOspGetlead?.payment_info?.amount
            : this.fniOspGetlead?.product?.down_payment *
              this.fniOspGetlead?.quantity
          : '',
      stock: this.stock,
      opty_id: this.opty_idfnijourney ? this.opty_idfnijourney : '',
      pan_no: this.encryptPanNOFni ? this.encryptPanNOFni : '',
      opty_status:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.STAGE_NAME_s
            ? this.fniUserData?.STAGE_NAME_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.opty_status_fnijourney
            ? this.opty_status_fnijourney
            : ''
          : '',
      aadhar_number: this.encryptAdharNOFni ? this.encryptAdharNOFni : '',
      dse_username:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.ASSIGN_LOGIN_s
            ? this.fniUserData?.ASSIGN_LOGIN_s
            : ''
          : this.typeOfBooking == 'FinanceJourney'
          ? this.dse_loginFni
          : '',
      source_of_contact:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.CHANNEL_TYPE_CD_s
            ? this.fniUserData?.CHANNEL_TYPE_CD_s
            : ''
          : 'Fleet Verse Web',
      channel:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.OPTY_CREATED_THROUGH_s
            ? this.fniUserData?.OPTY_CREATED_THROUGH_s
            : ''
          : this.typeOfBooking === 'FinanceJourney'
          ? this.fniOspGetlead?.lead_channel
          : this.isSmart || this.isViaConfigurator
          ? 'Fleet Verse Configurator' : 'Fleet Verse',
      contact_id:
        this.typeOfBooking === 'FinanceJourneyNonOsp'
          ? this.fniUserData?.PR_CON_ID_s
          : '',
      pincode: this.bookingFNIForm.value.pincode
        ? this.bookingFNIForm.value.pincode
        : '',
      taluka: this.bookingFNIForm.value.taluka
        ? this.bookingFNIForm.value.taluka
        : '',
      city: this.bookingFNIForm.value.city
        ? this.bookingFNIForm.value.city
        : '',
    };
    try {
      this.spinner.show();
      this.sub.add(
        this.apiService.fnijourney_create_lead(payLoad).subscribe({
          next: (res: any) => {
            if (res.success) {
              // this.generateChallengeToken(res.data)
              // this.getOptyID(res.data?.lead_row_id, res.data?.msg);
              this.reqID = res.data?.lead_row_id;
              this.getOptyID(res.data?.lead_row_id, res.data?.msg);
            } else {
              this.disableSubmitButton = false;
              this.spinner.hide();
              this.toastrService.warning(res.data.msg);
            }
          },
          error: () => {
            this.spinner.hide();
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  findDealersNew(){
    let payload = {
      "action_type":"state",
      "dealer_code":""
    }
  this.spinner.show();
  this.sub.add(this.apiService.getfindDealerNew(payload).subscribe({
      next: (res) => {
        if (res.success) {
        this.statesData=res.data
        this.spinner.hide();
        }
        else{
          this.toastrService.warning(res.data.msg);
          this.spinner.hide();
        }
      },
      error: (err) => {
      },complete: () => { }
    }));
  }
  findDealersNewParticular(index:any,data:any){
    this.selectedState = index;

    let payload = {
      "state": {
        "code": data.code,
        "state": data.name
        },
      "offset": 0,
      "size": 100
    }
  this.spinner.show();
  this.sub.add(this.apiService.getfindDealerNew(payload).subscribe({
      next: (res) => {
        if (res.success) {
        this.stateData=res.data
        this.spinner.hide();
        }
        else{
          this.stateData=[]
          this.toastrService.warning(res.data.msg);
          this.spinner.hide();
        }
      },
      error: (err) => {
      },complete: () => { }
    }));
  }
  getState(){
    if (this.statesData?.length > 0) {
      this.findDealersNewParticular(0,this.statesData[0])
      }
  }
  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }
  nAllowSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }
  getPaymentData(data:any){
    let payload = {
     "action_type":"payment_data",
    "row_id":data
  }
  // this.spi.show();
  this.sub.add(this.apiService.getLeadsnew(payload).subscribe({
      next: (res) => {
        if (res.success) {
       this.payment_data = res?.data?.payment_data
        // this.spinner.hide();
        }
        else{
          this.payment_data = [];
          // this.toastrService.warning(res.data.msg);
          // this.spinner.hide();
        }
      },
      error: (err) => {
      },complete: () => { }
    }));
  }
  userAaccumulation(data: any) {
    try {
      this.sub.add(
        this.apiService.addUserAaccumulation(data).subscribe({
          next: (res) => {
            if (res.success) {

            } else {

            }

          },
          error: (err) => {

          },
          complete: () => {

          },
        })
      );
    } catch (error) {

    }
  }
getLoyalitySignup() {
    const data = {
      mobile_number: this.userData?.mobile_number,
      first_name: this.userData?.first_name,
      last_name: this.userData?.last_name,
      email_id: this.userData?.email_id,
      created_source: "OSP",
      // user_type: "Customer",
      // user_tier: "Gold",
      // kyc: "Aadhar"
    };
    try {

      this.sub.add(
        this.apiService.signUpLoyality(data).subscribe({
          next: (res) => {
            if (res.success) {

            } else {
            }

          },
          error: (err) => {
          },
          complete: () => {
            // this.spinner.hide();
          },
        })
      );
    } catch (error) {}
  }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      let id = localStorage.getItem('tat_id');
      let Payload = {
        "id": id ? id:'',
        "home_configurator_request":"",
        "home_configurator_response":"" ,
        "osp_configurator_vas_filter_request":'',
        "osp_configurator_vas_filter_response":'',
        "request_id": data,
        "vehicle_number":"",
        "model":"" ,
        "number_of_vehicles": "",
        "application": '',
        "terrain":'',
        "annual_runnig":'',
        "duration_of_amc":'',
        "vas_offer":'',
        "amc": "",
        "fms": "",
        "ew": "",
        "oss": "",
        "fleetedge": "",
        "uptime_guarantee": "",
        "source": "",
        "vas_booking_price":"",
      };

      // this.spinner.show();

      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          // this.spinner.hide();
          if (res?.success) {
            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          // this.spinner.hide();
          reject(error);
        },
        complete: () => {
          // this.spinner.hide();
        }
      });
    });
  }
  getPanType(): string {
    let pandata = this.ispanData || this.fniOspGetlead?.lead_pan_no || this.fniUserData?.PR_CONTACT_PAN_s;
    
    if (pandata && pandata.length === 10) {
      return pandata[3] === 'P' ? 'Individual' : 'Company';
    }
    
    return this.userData?.account_type || ''; // Default to userData's account_type if available
  }
  companyNameError: boolean = false;

  validateCompanyName(event: any) {
    let inputValue = event.target.value;
    const restrictedChars = /[<>{}|~^*]/;
  
    if (restrictedChars.test(inputValue)) {
      this.companyNameError = true;
    } else {
      this.companyNameError = false;
    }
  
    inputValue = inputValue.replace(/[<>{}|~^*]/g, '');
    event.target.value = inputValue;
  
    this.bookingFNIForm.controls['full_name'].setValue(inputValue, { emitEvent: false });
  }
  
  checkCompanyNameError() {
    const fieldValue = this.bookingFNIForm.controls['full_name'].value;
    this.companyNameError = /[<>{}|~^*]/.test(fieldValue);
  }
  nameErrors: { [key: string]: boolean } = {
    first_name: false,
    last_name: false,
  };

  validateName(event: any, fieldName: string) {
    let inputValue = event.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(inputValue)) {
      this.nameErrors[fieldName] = true;
    } else {
      this.nameErrors[fieldName] = false;
    }
    inputValue = inputValue.replace(/[^a-zA-Z\s]/g, '');
    event.target.value = inputValue;
    this.bookingFNIForm.controls[fieldName].setValue(inputValue, {
      emitEvent: false,
    });
  }

  checkNameError(fieldName: string) {
    const fieldValue = this.bookingFNIForm.controls[fieldName].value;
    this.nameErrors[fieldName] = /[^a-zA-Z\s]/.test(fieldValue);
  }
  updateFirstNameValidation(accountType: string) {
    const firstNameControl = this.bookingFNIForm.get('first_name');   
    const lastNameControl = this.bookingFNIForm.get('last_name');
    const full_nameControl = this.bookingFNIForm.get('full_name');
    const aadhar_nameControl = this.bookingFNIForm.get('aadhar');


    if (firstNameControl && lastNameControl) {
      if (accountType === 'Individual') {
        firstNameControl.setValidators([
          Validators.required,
          this.individualNameValidator
        ]);
        lastNameControl.setValidators([
          this.individualNameValidator
        ]);
        full_nameControl.setValidators([
        ]);
        aadhar_nameControl.setValidators(
          [Validators.required, Validators.pattern(this.regexService.Aadhar)]);
      } else if (accountType === 'Company') {
        full_nameControl.setValidators([
          Validators.required,
          this.companyNameValidator
        ]);
        lastNameControl.setValidators([
        ]);
        firstNameControl.setValidators([
   
        ]);
        aadhar_nameControl.clearValidators();
      }
      this.getPanValue(event);
      firstNameControl.updateValueAndValidity();
      lastNameControl.updateValueAndValidity();
      full_nameControl?.updateValueAndValidity();
      aadhar_nameControl.updateValueAndValidity();
      this.bookingFNIForm.get('panNo')?.updateValueAndValidity();

    }
  }

  // Validator for Individual Names (Only Alphabets and Spaces)
  individualNameValidator(control: AbstractControl) {
    const nameRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
    return control.value && !nameRegex.test(control.value) ? { invalidIndividualName: true } : null;
  }

  // Validator for Company Names (Allow all except < > { } | ~ ^ *)
  companyNameValidator(control: AbstractControl) {
    const restrictedChars = /[<>{}|~^*]/; // Restricted special characters
    return control.value && restrictedChars.test(control.value) ? { invalidCompanyName: true } : null;
  }

  hasError(controlName: string, errorType: string) {
    return this.bookingFNIForm.get(controlName)?.hasError(errorType); //&& this.bookingFNIForm.get(controlName)?.touched;
  }
  hasPatterncheckError(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const panValue = control.value;
      if (!panValue) return null; // Allow empty value, no error
  
      if (panValue.length !== 10) return null; // Ignore if invalid length
  
      const panType = this.bookingFNIForm?.get('pan_type')?.value; // Get selected PAN type
      const fourthChar = panValue.charAt(3); // Get the 4th character
  
      if (panType === 'Individual' && fourthChar !== 'P') {
        return { invalidPanForIndividual: true }; // Error for Individual
      }
      if (panType === 'Company' && fourthChar === 'P') {
        return { invalidPanForCompany: true }; // Error for Company
      }
  
      return null; // No errors
    };
  }
    connectWebsocket(){
    this.startTimer(600)
    const uuid = uuidv4(); 
    this.socket_Id = 'WsKycVerificationId-' + this.userData?.mobile_number + '-' + uuid 
    let access_token = this.ssrcookieService.getItem('access_token') ? this.ssrcookieService.getItem('access_token') : null
  const kycUrl = environment.WEB_SOCKET_KYC
    const url = `${kycUrl}/${this.socket_Id}/?access_token=${access_token}`;
  
    this.sub.add(this.websocketService.connect(url));
     let count = 1;
    this.sub.add(this.behaviourSubject.websocketWhat.subscribe((isConnected) => {
   
     
      if (isConnected && count === 1) {
        this.sendWhatsAppCode(this.socket_Id)
        count++
      
      } else {
      
      }
    }));
  }
 sendWhatsAppCode(socket_id)
  {
     try {
    // this.spinner.show();
    let data = {
    "source" : "WsKycVerification",
    "mobile_number" : this.userData?.mobile_number,
    "socket_id":socket_id
    };
      this.sub.add(
        this.apiService.notifyOtpWhatsApp(data).subscribe({
          next: (response: any) => {
            if (response?.success) {
              this.isKycFetchedData = true
              // this.spinner.hide();
              if (response?.data?.SocketFormUrl) {
               this.sub.add(
                  this.websocketService.getMessages().pipe(
                    filter((response) => response?.success),
                    take(1)
                  ).subscribe({
                    next: (response) => {
                      this.spinner.hide();
                      console.log('Received from WebSocket:', response);

                      this.closeWebSocketConnection();
                      if(this.isKycFetchedData){
                        this.toastrService.success('KYC fetched successfully.');
                        this.isKycFetchedData = false;
                      }else{
                        return
                      }

                      const userData = response.data;

                      this.isAdhaarNoAvailable = userData?.address_proofs?.doc_number;
                      this.bookingFNIForm.controls['aadhar'].setValue(this.isAdhaarNoAvailable);
                      this.bookingFNIForm.controls["aadhar"].setValidators([Validators.pattern(this.regexService.Aadhar)]);
                      this.bookingFNIForm.get("aadhar").updateValueAndValidity();

                      const panNo = userData?.id_proofs?.doc_number; 
                      if (this.bookingFNIForm.controls["panNo"].value !== this.regexService.Pan) {
                        this.bookingFNIForm.controls["panNo"].setValidators([Validators.pattern(this.regexService.Pan)]);
                        this.bookingFNIForm.controls['panNo'].setValue(panNo);
                        this.bookingFNIForm.controls["panNo"].updateValueAndValidity();
                      }
                    },
                    error: (err) => {
                      this.spinner.hide();
                      this.isKycFetchedData = false;
                      console.error('WebSocket error:', err);
                      // this.toastrService.error('An error occurred while fetching KYC. Please try again.');
                      this.closeWebSocketConnection(); // Optional: Close if error happens
                    },
                    complete: () => {
                      console.log('WebSocket subscription completed');
                    }
                  })
                );
              }
              this.toastrService.success(response?.data?.msg);
            }
            else {
              this.closeWebSocketConnection()
                  this.toastrService.warning(response?.data?.msg);
                  this.spinner.hide();
                  this.isKycFetchedData = false;
                }
          },
          error: () => {
            this.closeWebSocketConnection()
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
            this.isKycFetchedData = false;
          },
          complete: () => { },
        })
      );
      } catch (error) {
    this.closeWebSocketConnection();
    this.isKycFetchedData = false;
    this.spinner.hide();
    console.error('Unexpected error:', error);
    this.toastrService.error('An unexpected error occurred.');
  }
  }
   startTimer(timeLeft: any) {
    this.timeLeft = timeLeft;
    const interval = setInterval(() => {
      this.isTimer = true;
      this.m = Math.floor(this.timeLeft / 60);
      this.s = this.timeLeft % 60;
      this.m = this.m < 10 ? '0' + this.m : this.m;
      this.s = this.s < 10 ? '0' + this.s : this.s;
      this.timeLeft--;
      if (this.timeLeft < 0) {
        this.isTimer = false;
        this.closeWebSocketConnection()
        clearInterval(interval);
      }
    }, 1000);
  }

    closeWebSocketConnection(){
    // this.showOtp()
    this.m = 0;
    this.s = 0;
    this.timeLeft = 0;
    this.sub.add(this.websocketService.disconnect());
    const ele = document.getElementById('closeBtn1')
    ele.click();
  }
  NumberKeyEvent(event: any, inputValue: string) {
    const ASCIICode = event.which ? event.which : event.keyCode;
  
    // Block non-numeric keys
    if (ASCIICode < 48 || ASCIICode > 57) return false;
  
    // Prevent first digit from being 0
    if (inputValue.length === 0 && ASCIICode === 48) return false;
  
    return true;
  }
}